// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.inv-form-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: 16px 18px;
}

.inv-field {
  display: flex;
  flex-direction: column;
  margin-bottom: 16px;
}

.inv-form-grid .inv-field {
  margin-bottom: 0;
}

.inv-field--full, .inv-key-notice {
  grid-column: 1/-1;
}

.inv-field label {
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin-bottom: 6px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.inv-field .form-control,
.inv-org-row .form-control {
  height: auto;
  padding: 9px 12px;
  font-size: 13px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #676a6c;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  background: #fff;
  box-shadow: none;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}
.inv-field .form-control::placeholder,
.inv-org-row .form-control::placeholder {
  color: #ccc;
}
.inv-field .form-control:focus,
.inv-org-row .form-control:focus {
  border-color: rgb(0, 173, 208);
  box-shadow: 0 0 0 3px rgba(0, 173, 208, 0.1);
  outline: none;
}

textarea.form-control {
  min-height: 240px;
  resize: vertical;
  line-height: 1.6;
}

.inv-field select.form-control,
.inv-org-row select.form-control {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 34px;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23949699' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  cursor: pointer;
}

.inv-field .form-control.ng-invalid.ng-touched,
.inv-org-row .form-control.ng-invalid.ng-touched {
  border-color: rgb(245, 67, 89);
}
.inv-field .form-control.ng-invalid.ng-touched:focus,
.inv-org-row .form-control.ng-invalid.ng-touched:focus {
  border-color: rgb(245, 67, 89);
  box-shadow: 0 0 0 3px rgba(245, 67, 89, 0.12);
}

.inv-error {
  margin-top: 5px;
  font-size: 11.5px;
  line-height: 1.4;
  color: rgb(245, 67, 89);
}

.inv-hint {
  margin: 5px 0 0;
  font-size: 11.5px;
  line-height: 1.4;
  color: #ccc;
}

.inv-locked {
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 38px;
  padding: 8px 12px;
  border: 1px dashed #e7eaec;
  border-radius: 6px;
  background: #f1f1f2;
  cursor: default;
}
.inv-locked__value {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: #ccc;
  line-height: 1.4;
}
.inv-locked__icon {
  flex: 0 0 auto;
  font-size: 11px;
  color: #ccc;
  opacity: 0.75;
}

.inv-locked-note {
  display: flex;
  align-items: flex-start;
  gap: 7px;
  margin: -6px 0 0;
  font-size: 11.5px;
  line-height: 1.45;
  color: #ccc;
}
.inv-locked-note::before {
  content: "\\f05a";
  font-family: FontAwesome;
  font-size: 11px;
  line-height: 1.45;
  opacity: 0.8;
}

.inv-note {
  display: flex;
  align-items: flex-start;
  gap: 9px;
  padding: 10px 12px;
  border: 1px solid rgba(0, 173, 208, 0.28);
  border-radius: 8px;
  background: rgba(0, 173, 208, 0.06);
}
.inv-note__icon {
  flex: 0 0 auto;
  margin-top: 1px;
  font-size: 13px;
  color: rgb(0, 173, 208);
}
.inv-note__text {
  margin: 0;
  font-size: 12.5px;
  line-height: 1.5;
  color: #676a6c;
}
.inv-note__text strong {
  font-weight: 600;
}

.inv-field--full {
  flex-direction: row;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #676a6c;
}

.inv-role-note {
  background: #f1f1f2;
  border: 1px solid #e7eaec;
  border-radius: 6px;
  padding: 12px 14px;
  margin-bottom: 16px;
  font-size: 12.5px;
  line-height: 1.55;
  color: #676a6c;
}
.inv-role-note ul {
  margin: 6px 0 0;
  padding-left: 18px;
}
.inv-role-note li {
  margin: 2px 0;
}
.inv-role-note strong {
  color: #6d6e71;
}

.inv-key-notice {
  background: #fff8e6;
  border: 1px solid #f3e0a8;
  border-radius: 6px;
  padding: 10px 14px;
  font-size: 12px;
  color: #8a6d1a;
  line-height: 1.5;
}

.inv-section-title {
  font-size: 12px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: #6d6e71;
  margin: 26px 0 16px;
  padding-top: 20px;
  border-top: 1px solid #e7eaec;
}

@media (min-width: 720px) {
  .inv-form-grid--pairs {
    grid-template-columns: 1fr 1fr;
  }
}
img {
  max-width: 100%;
}

.flex {
  display: flex;
  flex-wrap: wrap;
}

.dir-col {
  flex-direction: column;
}

.dir-col-rev {
  flex-direction: column-reverse;
}

.mh-full {
  min-height: 100%;
}

.mt-auto {
  margin-top: auto;
}

.bt-0 {
  border-top: 0;
}

.bb-0 {
  border-bottom: 0;
}

.fn-body h1,
.fn-body h2,
.fn-body h3,
.fn-body h4,
.fn-body h5,
.fn-body h6 {
  --hGap: 10px;
  font-family: "Museo-700";
  color: #6d6e71;
  margin-bottom: var(--hGap);
  margin-top: 0;
}
.fn-body h1:last-child,
.fn-body h2:last-child,
.fn-body h3:last-child,
.fn-body h4:last-child,
.fn-body h5:last-child,
.fn-body h6:last-child {
  margin-bottom: 0;
}
.fn-body h1,
.fn-body .h1-text {
  font-size: 44px;
  line-height: 1.1;
}
@media only screen and (max-width: 767px) {
  .fn-body h1,
  .fn-body .h1-text {
    font-size: 38px;
  }
}
.fn-body h2,
.fn-body .h2-text {
  font-size: 38px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h2,
  .fn-body .h2-text {
    font-size: 32px;
  }
}
.fn-body h3,
.fn-body .h3-text {
  font-size: 32px;
  line-height: 1.2;
}
@media only screen and (max-width: 767px) {
  .fn-body h3,
  .fn-body .h3-text {
    font-size: 24px;
  }
}
.fn-body h4,
.fn-body .h4-text {
  font-size: 24px;
  line-height: 1.2;
}
.fn-body h5,
.fn-body .h5-text {
  font-size: 18px;
  line-height: 1.2;
}
.fn-body h6,
.fn-body .h6-text {
  font-size: 16px;
  line-height: 1.3;
}
.fn-body p {
  font-size: 18px;
  line-height: 1.6;
  color: #6a6a6a;
  margin-top: 0;
  margin-bottom: 10px;
}
.fn-body p:last-child {
  margin-bottom: 0;
}
@media only screen and (max-width: 767px) {
  .fn-body p {
    font-size: 16px;
  }
}
.fn-body ul,
.fn-body ol {
  padding: 0;
  margin: 0;
}
.fn-body sup {
  font-size: 0.7em;
  position: relative;
  top: 5px;
  display: inline-block;
  vertical-align: top;
}

.bg-grey {
  background-color: #eee;
}

.fn-container {
  max-width: 1080px;
  width: calc(100% - 30px);
  margin-inline: auto;
}
@media only screen and (min-width: 992px) {
  .fn-container {
    margin-left: 0;
  }
}
.fn-container--fluid {
  max-width: 1200px;
}
.fn-container--small {
  max-width: 820px;
  width: 100%;
}

.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}

.d-none {
  display: none;
}

.section-title {
  text-align: center;
}
.section-title:not(:last-child) {
  margin-bottom: 40px;
}
.section-title h2:not(:last-child) {
  margin-block-end: 20px;
}
.section-title p {
  max-width: 900px;
  width: 100%;
  margin-inline: auto;
  font-size: 22px;
}
.section-title p:not(:last-child) {
  margin-block-end: 20px;
}
@media only screen and (max-width: 767px) {
  .section-title p {
    font-size: 18px;
  }
}
.section-title .section-title__linkcontainer {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
}
.section-title .section-title__linkcontainer:not(:last-child) {
  margin-block-end: 20px;
}
.section-title .section-title__linkcontainer > * {
  margin: 5px;
}
.section-title .section-title__linkcontainer .fn-btn {
  padding-block: 6px;
  padding-inline: 13px;
  font-size: 12px;
  font-family: "MuseoSans-300";
}

.section-padding {
  padding-block: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding {
    padding-block: 40px;
  }
}
.section-padding-small {
  padding-block: 30px;
}
.section-padding-all {
  padding: 60px;
}
@media only screen and (max-width: 767px) {
  .section-padding-all {
    padding: 30px;
  }
}
.section-padding-all-small {
  padding: 30px;
}

.headline {
  --lineSize: 10px;
  width: -moz-fit-content;
  width: fit-content;
  padding-block-end: calc(10px + var(--lineSize));
  margin-inline: auto;
  position: relative;
}
.headline--small-border {
  --lineSize: 6px;
}
.headline:not(:last-child) {
  margin-bottom: calc(var(--hGap) * 2.5);
}
.headline::before {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: var(--lineSize);
  background: linear-gradient(90deg, rgb(0, 173, 208) 0%, rgb(0, 173, 208) 25%, rgb(255, 121, 0) 25%, rgb(255, 121, 0) 50%, rgb(105, 190, 40) 50%, rgb(105, 190, 40) 75%, rgb(245, 67, 89) 75%, rgb(245, 67, 89) 100%);
}

.custom-list li {
  font-size: 18px;
  line-height: 1.4;
  color: #6a6a6a;
  list-style: none;
  position: relative;
  padding-left: 15px;
}
.custom-list li:not(:last-child) {
  margin-bottom: 4px;
}
.custom-list li::before {
  content: "";
  position: absolute;
  top: 10px;
  left: 0;
  width: 3px;
  height: 3px;
  background-color: var(--clrProfile);
}

.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.fn-btn {
  padding-block: 20px;
  padding-inline: 28px;
  background-color: rgb(105, 190, 40);
  color: #fff;
  font-size: 18px;
  line-height: 1.2;
  display: inline-block;
  font-family: "Museo-700";
  text-decoration: none;
  word-break: break-all;
  text-align: center;
  transition: background-color 0.3s;
}
.fn-btn:focus {
  outline: 1px dashed #6a6a6a;
  outline-offset: 4px;
}
.fn-btn:hover {
  background-color: #6d6e71;
  color: #fff;
}
.fn-btn--sm {
  font-size: 14px;
  padding-block: 10px;
  padding-inline: 20px;
}
.fn-btn--grey {
  background-color: #f1f1f2;
  color: #6d6e71;
}
.fn-btn--ongoing {
  background-color: #f8ac59;
  color: #fff;
}
.fn-btn--ongoing i {
  animation: spin 0.3s infinite;
}

@keyframes spin {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}
.color-clarify {
  --clrProfile: rgb(0, 173, 208);
}

.color-ideate {
  --clrProfile: rgb(255, 121, 0);
}

.color-develop {
  --clrProfile: rgb(105, 190, 40);
}

.color-implement {
  --clrProfile: rgb(245, 67, 89);
}

.w-4 {
  width: 33.3333333333%;
}

.w-3 {
  width: 25%;
}
.w-3--wd {
  width: 33.3333333333%;
}

.w-6 {
  width: 50%;
}

.fn-row {
  --rGap: 15px;
  --rGap-minus: calc(-1 * var(--rGap));
  display: flex;
  flex-wrap: wrap;
  margin-inline: var(--rGap-minus);
}
.fn-row--col-gap-exist .fn-col {
  margin-bottom: 30px;
}
.fn-col {
  padding-inline: var(--rGap);
}
.fn-justify-center {
  justify-content: center;
}
.fn-items-center {
  align-items: center;
}

.mx-auto {
  margin-inline: auto;
}
.ml-auto {
  margin-inline-start: auto;
}
.ml-0 {
  margin-inline-start: 0;
}
.mr-auto {
  margin-inline-end: auto;
}
.mr-0 {
  margin-inline-end: 0;
}

.rep-pill {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  border-radius: 10px;
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 600;
  white-space: nowrap;
  background: #f1f1f2;
  color: #6d6e71;
  border: 1px solid #e7eaec;
}
.rep-pill__icon {
  font-size: 10px;
  color: #6a6a6a;
}

.rep-avatar {
  display: inline-flex;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  background: #6d6e71;
  color: #fff;
  align-items: center;
  justify-content: center;
  font-size: 9px;
  font-weight: 700;
  flex-shrink: 0;
}
.rep-avatar--grey {
  background: #e7eaec;
  color: #6d6e71;
}

.repw {
  padding: 32px 48px 48px;
  max-width: 1120px;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
}

.repw .inv-field {
  max-width: 680px;
}

.repw .rep-typefield {
  max-width: none;
}

.repw-header {
  margin-bottom: 22px;
}

.repw-card {
  background: #fff;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  padding: 26px 28px;
}
@media (max-width: 640px) {
  .repw-card {
    padding: 20px 18px;
  }
}

.repw-breadcrumb {
  list-style: none;
  padding: 0;
  margin: 0 0 8px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #ccc;
}
.repw-breadcrumb li {
  display: flex;
  align-items: center;
}
.repw-breadcrumb li:not(:last-child)::after {
  content: "/";
  margin: 0 8px;
  color: #ccc;
  font-size: 11px;
}
.repw-breadcrumb a {
  color: #676a6c;
  text-decoration: none;
  transition: color 0.15s ease;
}
.repw-breadcrumb a:hover {
  color: rgb(0, 173, 208);
}
.repw-breadcrumb__current {
  color: #6d6e71;
  font-weight: 600;
}

.repw-header__title {
  font-size: 28px;
  font-weight: 700;
  color: #6d6e71;
  margin: 0;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.rep-steps {
  display: flex;
  list-style: none;
  padding: 0;
  margin: 0 0 22px;
}
.rep-steps__item {
  display: flex;
  align-items: center;
  gap: 7px;
  flex: 1;
  min-width: 0;
  color: #ccc;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.rep-steps__item:last-child {
  flex: 0 0 auto;
}
.rep-steps__item::after {
  content: "";
  flex: 1;
  height: 2px;
  min-width: 18px;
  margin: 0 12px;
  background: #eef0f1;
  border-radius: 2px;
}
.rep-steps__item:last-child::after {
  display: none;
}
.rep-steps__item.is-done::after {
  background: rgb(0, 173, 208);
}
.rep-steps__item:hover .rep-steps__label {
  color: rgb(0, 173, 208);
}
.rep-steps__item:focus-visible {
  outline: 2px solid rgb(0, 173, 208);
  outline-offset: 2px;
}
.rep-steps__num {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  border-radius: 50%;
  background: #eef0f1;
  color: #ccc;
  font-size: 11px;
  flex-shrink: 0;
}
.rep-steps__label {
  white-space: nowrap;
}
.rep-steps__item.is-active {
  color: rgb(0, 173, 208);
}
.rep-steps__item.is-active .rep-steps__num, .rep-steps__item.is-done .rep-steps__num {
  background: rgb(0, 173, 208);
  color: #fff;
}

@media (max-width: 560px) {
  .rep-steps__label {
    display: none;
  }
}
.rep-hint {
  margin: 5px 0 0;
  font-size: 11.5px;
  line-height: 1.4;
  color: #676a6c;
}

.rep-typegrid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 12px;
  margin-top: 2px;
}
@media (max-width: 900px) {
  .rep-typegrid {
    grid-template-columns: 1fr;
  }
}

.rep-typecard {
  display: flex;
  flex-direction: column;
  gap: 6px;
  position: relative;
  padding: 16px 16px 14px;
  text-align: left;
  border: 1px solid #e7eaec;
  border-radius: 10px;
  background: #fff;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;
  overflow: hidden;
}
.rep-typecard:hover {
  border-color: #ccc;
}
.rep-typecard:focus-visible {
  outline: 2px solid rgb(0, 173, 208);
  outline-offset: 2px;
}
.rep-typecard__img {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 5px;
  height: 190px;
  margin: -16px -16px 12px;
  background: #f1f1f2;
  border-bottom: 1px solid #e7eaec;
  color: #ccc;
}
.rep-typecard__img .fa {
  font-size: 24px;
  opacity: 0.7;
}
.rep-typecard__img span {
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.07em;
}
.rep-typecard.is-selected .rep-typecard__img {
  background: rgba(0, 173, 208, 0.08);
  color: #008ba7;
}
.rep-typecard.is-selected {
  border-color: rgb(0, 173, 208);
  background: rgba(0, 173, 208, 0.04);
  box-shadow: inset 0 0 0 1px rgb(0, 173, 208);
}
.rep-typecard__radio {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  border: 1px solid #e7eaec;
  background: #fff;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}
.rep-typecard__radio .fa {
  font-size: 9px;
  color: #fff;
  opacity: 0;
  transition: opacity 0.15s ease;
}
.rep-typecard.is-selected .rep-typecard__radio {
  border-color: rgb(0, 173, 208);
  background: rgb(0, 173, 208);
}
.rep-typecard.is-selected .rep-typecard__radio .fa {
  opacity: 1;
}
.rep-typecard__title {
  font-size: 14px;
  font-weight: 700;
  color: #6d6e71;
  padding-right: 24px;
}
.rep-typecard__desc {
  font-size: 12px;
  line-height: 1.45;
  color: #676a6c;
  flex: 1;
}
.rep-typecard__key {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  font-size: 11.5px;
  font-weight: 600;
  color: #6d6e71;
}
.rep-typecard__key .fa {
  font-size: 11px;
  color: #ccc;
}
.rep-typecard__key.is-free {
  color: #4a8c1c;
}
.rep-typecard__key.is-free .fa {
  color: #4a8c1c;
}
.rep-typecard__foot {
  margin-top: 8px;
  padding-top: 10px;
  border-top: 1px solid #f1f1f2;
}
.rep-typecard__price {
  font-size: 11.5px;
  font-weight: 700;
  color: #4a8c1c;
}
.rep-typecard__soon {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-size: 11px;
  color: #676a6c;
  font-style: italic;
}
.rep-typecard__soon .fa {
  font-size: 11px;
}

.rep-buybtn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  font-size: 12px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border: 1px solid rgb(105, 190, 40);
  border-radius: 6px;
  background: rgb(105, 190, 40);
  color: #fff;
  cursor: pointer;
  transition: background 0.15s ease, border-color 0.15s ease;
}
.rep-buybtn .fa {
  font-size: 11px;
}
.rep-buybtn:hover {
  background: #569c21;
  border-color: #569c21;
}
.rep-buybtn:focus-visible {
  outline: 2px solid rgb(0, 173, 208);
  outline-offset: 2px;
}

.repw__footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
  margin: 24px -28px 0;
  padding: 16px 28px 0;
  border-top: 1px solid #e7eaec;
}
@media (max-width: 640px) {
  .repw__footer {
    margin: 20px -18px 0;
    padding: 14px 18px 0;
  }
}

.repw__cancel {
  color: rgb(0, 173, 208);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}
.repw__cancel:hover {
  text-decoration: underline;
}

.repw__actions {
  display: flex;
  align-items: center;
  gap: 10px;
}

.repw__block {
  font-size: 12px;
  color: #676a6c;
}

.repw__footer .btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 9px 18px;
  font-size: 13px;
  font-weight: 600;
  font-family: "open sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  line-height: 1.4;
  box-shadow: none;
  transition: all 0.15s ease;
}

.repw__footer .btn-primary {
  background: rgb(105, 190, 40);
  color: #fff;
  border-color: rgb(105, 190, 40);
}
.repw__footer .btn-primary:hover {
  background: #569c21;
  border-color: #569c21;
}

.repw__footer .btn-white {
  background: #fff;
  color: #676a6c;
  border-color: #e7eaec;
}
.repw__footer .btn-white:hover {
  background: #f1f1f2;
  border-color: #ccc;
}

.repr {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 620px;
}

.repr-summary {
  margin: 0;
  border: 1px solid #e7eaec;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
}
.repr-summary__row {
  display: flex;
  gap: 16px;
  padding: 11px 14px;
  border-bottom: 1px solid #f1f1f2;
}
.repr-summary__row:last-child {
  border-bottom: 0;
}
.repr-summary dt {
  width: 110px;
  flex-shrink: 0;
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #676a6c;
  padding-top: 2px;
}
.repr-summary dd {
  margin: 0;
  font-size: 13px;
  color: #6d6e71;
  font-weight: 600;
}
.repr-summary__sub {
  font-weight: 400;
  color: #676a6c;
}

.repr-mix, .repr-byorg {
  border: 1px solid #e7eaec;
  border-radius: 8px;
  background: #fafafa;
  padding: 12px 14px;
}
.repr-mix__label, .repr-byorg__label {
  font-size: 10.5px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #676a6c;
  display: block;
  margin-bottom: 8px;
}
.repr-mix__row, .repr-byorg__row {
  display: flex;
  justify-content: space-between;
  gap: 12px;
  font-size: 12.5px;
  margin-bottom: 4px;
}
.repr-mix__name, .repr-byorg__name {
  color: #676a6c;
}
.repr-mix__n, .repr-byorg__n {
  font-weight: 700;
  color: #6d6e71;
}
.repr-mix__n.is-zero, .repr-byorg__n.is-zero {
  color: rgb(245, 67, 89);
}
.repr-mix__note, .repr-byorg__note {
  font-size: 10.5px;
  color: #676a6c;
  margin: 8px 0 0;
}

.repr-warn {
  display: flex;
  gap: 8px;
  font-size: 12px;
  line-height: 1.45;
  border-radius: 6px;
  padding: 10px 12px;
  background: #fff4e5;
  color: #8a5a00;
}
.repr-warn i {
  margin-top: 1px;
}
.repr-warn--cap {
  background: #fdeaec;
  color: #a3283a;
}

@media (max-width: 991px) {
  .repw {
    padding: 24px 24px 40px;
  }
}
@media (max-width: 640px) {
  .repw {
    padding: 16px 16px 32px;
  }
  .rep-steps {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/_variables.scss","webpack://./src/app/components/reports/wizard/report-wizard.component.scss","webpack://./src/app/components/invitations/_inv-form.scss","webpack://./src/app/components/reports/_rep-shared.scss"],"names":[],"mappings":"AAgIA;EACE,eAAA;AC/HF;;ADkIA;EACE,aAAA;EACA,eAAA;AC/HF;;ADkIA;EACE,sBAAA;AC/HF;;ADkIA;EACE,8BAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;ADkIA;EACE,aAAA;AC/HF;;ADkIA;EACE,gBAAA;AC/HF;;AD6IE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;AC1IJ;AD4II;;;;;;EACE,gBAAA;ACrIN;ADyIE;;EAEE,eA5GO;EA6GP,gBA3GO;AC5BX;ADyII;EALF;;IAMI,eA/GY;ECtBhB;AACF;ADwIE;;EAEE,eAlHO;EAmHP,gBAjHO;ACrBX;ADwII;EALF;;IAMI,eArHY;ECfhB;AACF;ADuIE;;EAEE,eAxHO;EAyHP,gBAvHO;ACdX;ADuII;EALF;;IAMI,eA3HY;ECRhB;AACF;ADsIE;;EAEE,eA9HO;EA+HP,gBA7HO;ACPX;ADuIE;;EAEE,eAhIO;EAiIP,gBAhIO;ACLX;ADwIE;;EAEE,eAnIO;EAoIP,gBAnIO;ACHX;AD4IE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;AC1IJ;AD4II;EACE,gBAAA;AC1IN;AD6II;EAXF;IAYI,eAAA;EC1IJ;AACF;AD6IE;;EAEE,UAAA;EACA,SAAA;AC3IJ;AD8IE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC5IJ;;ADgJA;EACE,sBAxNQ;AC2EV;;ADgJA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC7IF;AD+IE;EALF;IAMI,cAAA;EC5IF;AACF;AD8IE;EACE,iBA1Ka;AC8BjB;AD+IE;EACE,gBApLa;EAqLb,WAAA;AC7IJ;;ADkJE;EACE,kBAAA;AC/IJ;ADkJE;EACE,iBAAA;AChJJ;;ADqJE;EACE,aAAA;AClJJ;;ADsJA;EACE,kBAAA;ACnJF;ADqJE;EACE,mBAAA;ACnJJ;ADuJI;EACE,sBAAA;ACrJN;ADyJE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACuEnB;ADyJI;EACE,sBAAA;ACvJN;AD0JI;EAVF;IAWI,eApOoB;EC6ExB;AACF;AD0JE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACxJJ;AD0JI;EACE,sBAAA;ACxJN;AD2JI;EACE,WAAA;ACzJN;AD4JI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACkMZ;;AD+JA;EACE,mBA1PO;AC8FT;AD8JE;EAHF;IAII,mBAAA;EC3JF;AACF;AD6JE;EACE,mBAAA;AC3JJ;AD8JE;EACE,aArQK;ACyGT;AD8JI;EAHF;IAII,aAAA;EC3JJ;AACF;AD6JI;EACE,aAAA;AC3JN;;ADgKA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC7JF;AD+JE;EACE,eAAA;AC7JJ;ADgKE;EACE,sCAAA;AC9JJ;ADiKE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC/JJ;;AD8KE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;AC3KJ;AD6KI;EACE,kBAAA;AC3KN;AD8KI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC5KN;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,+BAAA;AC9KF;;ADiLA;EACE,8BAAA;AC9KF;;ADiLA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC9KF;ADgLE;EACE,2BAAA;EACA,mBAAA;AC9KJ;ADiLE;EACE,yBAzbiB;EA0bjB,WA1aO;AC2PX;ADkLE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AChLJ;ADmLE;EACE,yBAjckB;EAkclB,cArciB;ACoRrB;ADoLE;EACE,yBAvbS;EAwbT,WA1bO;ACwQX;ADoLI;EACE,6BAAA;AClLN;;ADuLA;EACE;IACE,uBAAA;ECpLF;EDuLA;IACE,yBAAA;ECrLF;AACF;ADwLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,+BAAA;ACtLF;;ADyLA;EACE,8BAAA;ACtLF;;ADyLA;EACE,qBAAA;ACtLF;;ADyLA;EACE,UAAA;ACtLF;ADwLE;EACE,qBAAA;ACtLJ;;AD0LA;EACE,UAAA;ACvLF;;AD2LE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACzLJ;AD4LM;EACE,mBAAA;AC1LR;AD+LE;EACE,2BAAA;AC7LJ;ADgME;EACE,uBAAA;AC9LJ;ADiME;EACE,mBAAA;AC/LJ;;ADoME;EACE,mBAAA;ACjMJ;ADoME;EACE,yBAAA;AClMJ;ADqME;EACE,sBAAA;ACnMJ;ADsME;EACE,uBAAA;ACpMJ;ADuME;EACE,oBAAA;ACrMJ;;AD/QA;EACE,eAAA;ACkRF;;AD/QA;EACE,aAAA;EACA,eAAA;ACkRF;;AD/QA;EACE,sBAAA;ACkRF;;AD/QA;EACE,8BAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;AD/QA;EACE,aAAA;ACkRF;;AD/QA;EACE,gBAAA;ACkRF;;ADpQE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACuQJ;ADrQI;;;;;;EACE,gBAAA;AC4QN;ADxQE;;EAEE,eA5GO;EA6GP,gBA3GO;ACqXX;ADxQI;EALF;;IAMI,eA/GY;EC2XhB;AACF;ADzQE;;EAEE,eAlHO;EAmHP,gBAjHO;AC4XX;ADzQI;EALF;;IAMI,eArHY;ECkYhB;AACF;AD1QE;;EAEE,eAxHO;EAyHP,gBAvHO;ACmYX;AD1QI;EALF;;IAMI,eA3HY;ECyYhB;AACF;AD3QE;;EAEE,eA9HO;EA+HP,gBA7HO;AC0YX;AD1QE;;EAEE,eAhIO;EAiIP,gBAhIO;AC4YX;ADzQE;;EAEE,eAnIO;EAoIP,gBAnIO;AC8YX;ADrQE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACuQJ;ADrQI;EACE,gBAAA;ACuQN;ADpQI;EAXF;IAYI,eAAA;ECuQJ;AACF;ADpQE;;EAEE,UAAA;EACA,SAAA;ACsQJ;ADnQE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;ACqQJ;;ADjQA;EACE,sBAxNQ;AC4dV;;ADjQA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;ACoQF;ADlQE;EALF;IAMI,cAAA;ECqQF;AACF;ADnQE;EACE,iBA1Ka;AC+ajB;ADlQE;EACE,gBApLa;EAqLb,WAAA;ACoQJ;;AD/PE;EACE,kBAAA;ACkQJ;AD/PE;EACE,iBAAA;ACiQJ;;AD5PE;EACE,aAAA;AC+PJ;;AD3PA;EACE,kBAAA;AC8PF;AD5PE;EACE,mBAAA;AC8PJ;AD1PI;EACE,sBAAA;AC4PN;ADxPE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACwdnB;ADxPI;EACE,sBAAA;AC0PN;ADvPI;EAVF;IAWI,eApOoB;EC8dxB;AACF;ADvPE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACyPJ;ADvPI;EACE,sBAAA;ACyPN;ADtPI;EACE,WAAA;ACwPN;ADrPI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;ACmlBZ;;ADlPA;EACE,mBA1PO;AC+eT;ADnPE;EAHF;IAII,mBAAA;ECsPF;AACF;ADpPE;EACE,mBAAA;ACsPJ;ADnPE;EACE,aArQK;AC0fT;ADnPI;EAHF;IAII,aAAA;ECsPJ;AACF;ADpPI;EACE,aAAA;ACsPN;;ADjPA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;ACoPF;ADlPE;EACE,eAAA;ACoPJ;ADjPE;EACE,sCAAA;ACmPJ;ADhPE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;ACkPJ;;ADnOE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACsOJ;ADpOI;EACE,kBAAA;ACsON;ADnOI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;ACqON;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,+BAAA;ACmOF;;ADhOA;EACE,8BAAA;ACmOF;;ADhOA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;ACmOF;ADjOE;EACE,2BAAA;EACA,mBAAA;ACmOJ;ADhOE;EACE,yBAzbiB;EA0bjB,WA1aO;AC4oBX;AD/NE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;ACiOJ;AD9NE;EACE,yBAjckB;EAkclB,cArciB;ACqqBrB;AD7NE;EACE,yBAvbS;EAwbT,WA1bO;ACypBX;AD7NI;EACE,6BAAA;AC+NN;;AD1NA;EACE;IACE,uBAAA;EC6NF;ED1NA;IACE,yBAAA;EC4NF;AACF;ADzNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,+BAAA;AC2NF;;ADxNA;EACE,8BAAA;AC2NF;;ADxNA;EACE,qBAAA;AC2NF;;ADxNA;EACE,UAAA;AC2NF;ADzNE;EACE,qBAAA;AC2NJ;;ADvNA;EACE,UAAA;AC0NF;;ADtNE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACwNJ;ADrNM;EACE,mBAAA;ACuNR;ADlNE;EACE,2BAAA;ACoNJ;ADjNE;EACE,uBAAA;ACmNJ;ADhNE;EACE,mBAAA;ACkNJ;;AD7ME;EACE,mBAAA;ACgNJ;AD7ME;EACE,yBAAA;AC+MJ;AD5ME;EACE,sBAAA;AC8MJ;AD3ME;EACE,uBAAA;AC6MJ;AD1ME;EACE,oBAAA;AC4MJ;;ACpxBA;EAAiB,aAAA;EAAe,0BAAA;EAA4B,cAAA;AD0xB5D;;ACzxBA;EAAa,aAAA;EAAe,sBAAA;EAAwB,mBAAA;AD+xBpD;;AC9xBA;EAA4B,gBAAA;ADkyB5B;;ACjyBA;EAAoC,iBAAA;ADqyBpC;;ACnyBA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cFmBmB;EElBnB,kBAAA;EACA,wEFvBW;AC6zBb;;ACnyBA;;EAEE,YAAA;EACA,iBAAA;EACA,eAAA;EACA,wEF/BW;EEgCX,cFGmB;EEFnB,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;EACA,wDAAA;ADsyBF;ACpyBE;;EAAiB,WFGC;ACqyBpB;ACvyBE;;EAAU,8BFnBI;EEmB0B,4CAAA;EAAiD,aAAA;AD6yB3F;;AC3yBA;EAAwB,iBAAA;EAAmB,gBAAA;EAAkB,gBAAA;ADizB7D;;AC3yBA;;EAEE,gBAAA;EACA,wBAAA;EACA,mBAAA;EACA,wQAAA;EACA,4BAAA;EACA,sCAAA;EACA,eAAA;AD8yBF;;AC1yBA;;EAEE,8BFtCgB;ACm1BlB;AC5yBE;;EAAU,8BFvCM;EEuC0B,6CAAA;ADizB5C;;AC/yBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,uBF7CgB;AC+1BlB;;AC/yBA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,WFlCkB;ACo1BpB;;AC7yBA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,gBAAA;EACA,iBAAA;EACA,0BAAA;EACA,kBAAA;EACA,mBF9CoB;EE+CpB,eAAA;ADgzBF;AC9yBE;EACE,OAAA;EACA,YAAA;EACA,eAAA;EACA,WFtDgB;EEuDhB,gBAAA;ADgzBJ;AC9yBE;EACE,cAAA;EACA,eAAA;EACA,WF5DgB;EE6DhB,aAAA;ADgzBJ;;AC3yBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WFzEkB;ACu3BpB;AC5yBE;EACE,gBAAA;EACA,wBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;AD8yBJ;;ACzyBA;EACE,aAAA;EACA,uBAAA;EACA,QAAA;EACA,kBAAA;EACA,yCAAA;EACA,kBAAA;EACA,mCAAA;AD4yBF;AC1yBE;EACE,cAAA;EACA,eAAA;EACA,eAAA;EACA,uBFvHY;ACm6BhB;AC1yBE;EACE,SAAA;EACA,iBAAA;EACA,gBAAA;EACA,cF/GiB;AC25BrB;AC3yBI;EAAS,gBAAA;AD8yBb;;ACzyBA;EACE,mBAAA;EACA,mBAAA;EACA,QAAA;EACA,eAAA;EACA,cF1HmB;ACs6BrB;;ACxyBA;EACE,mBFvHoB;EEwHpB,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,iBAAA;EACA,cFtImB;ACi7BrB;ACzyBE;EAAK,eAAA;EAAiB,kBAAA;AD6yBxB;AC5yBE;EAAK,aAAA;AD+yBP;AC9yBE;EAAS,cFrIU;ACs7BrB;;AC7yBA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;ADgzBF;;AC5yBA;EACE,eAAA;EACA,gBAAA;EACA,yBAAA;EACA,sBAAA;EACA,cFzJmB;EE0JnB,mBAAA;EACA,iBAAA;EACA,6BAAA;AD+yBF;;AC1yBA;EACE;IAAwB,8BAAA;ED8yBxB;AACF;AD13BA;EACE,eAAA;AC43BF;;ADz3BA;EACE,aAAA;EACA,eAAA;AC43BF;;ADz3BA;EACE,sBAAA;AC43BF;;ADz3BA;EACE,8BAAA;AC43BF;;ADz3BA;EACE,gBAAA;AC43BF;;ADz3BA;EACE,gBAAA;AC43BF;;ADz3BA;EACE,aAAA;AC43BF;;ADz3BA;EACE,gBAAA;AC43BF;;AD92BE;;;;;;EAME,YAAA;EACA,wBA7KO;EA8KP,cA3IiB;EA4IjB,0BAAA;EACA,aAAA;ACi3BJ;AD/2BI;;;;;;EACE,gBAAA;ACs3BN;ADl3BE;;EAEE,eA5GO;EA6GP,gBA3GO;AC+9BX;ADl3BI;EALF;;IAMI,eA/GY;ECq+BhB;AACF;ADn3BE;;EAEE,eAlHO;EAmHP,gBAjHO;ACs+BX;ADn3BI;EALF;;IAMI,eArHY;EC4+BhB;AACF;ADp3BE;;EAEE,eAxHO;EAyHP,gBAvHO;AC6+BX;ADp3BI;EALF;;IAMI,eA3HY;ECm/BhB;AACF;ADr3BE;;EAEE,eA9HO;EA+HP,gBA7HO;ACo/BX;ADp3BE;;EAEE,eAhIO;EAiIP,gBAhIO;ACs/BX;ADn3BE;;EAEE,eAnIO;EAoIP,gBAnIO;ACw/BX;AD/2BE;EACE,eAAA;EACA,gBAAA;EACA,cAzMqB;EA0MrB,aAAA;EACA,mBAAA;ACi3BJ;AD/2BI;EACE,gBAAA;ACi3BN;AD92BI;EAXF;IAYI,eAAA;ECi3BJ;AACF;AD92BE;;EAEE,UAAA;EACA,SAAA;ACg3BJ;AD72BE;EACE,gBAAA;EACA,kBAAA;EACA,QAAA;EACA,qBAAA;EACA,mBAAA;AC+2BJ;;AD32BA;EACE,sBAxNQ;ACskCV;;AD32BA;EACE,iBAlKU;EAmKV,wBAAA;EACA,mBAAA;AC82BF;AD52BE;EALF;IAMI,cAAA;EC+2BF;AACF;AD72BE;EACE,iBA1Ka;ACyhCjB;AD52BE;EACE,gBApLa;EAqLb,WAAA;AC82BJ;;ADz2BE;EACE,kBAAA;AC42BJ;ADz2BE;EACE,iBAAA;AC22BJ;;ADt2BE;EACE,aAAA;ACy2BJ;;ADr2BA;EACE,kBAAA;ACw2BF;ADt2BE;EACE,mBAAA;ACw2BJ;ADp2BI;EACE,sBAAA;ACs2BN;ADl2BE;EACE,gBAAA;EACA,WAAA;EACA,mBAAA;EACA,eA9Ne;ACkkCnB;ADl2BI;EACE,sBAAA;ACo2BN;ADj2BI;EAVF;IAWI,eApOoB;ECwkCxB;AACF;ADj2BE;EACE,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;ACm2BJ;ADj2BI;EACE,sBAAA;ACm2BN;ADh2BI;EACE,WAAA;ACk2BN;AD/1BI;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,4BA5VM;AC6rCZ;;AD51BA;EACE,mBA1PO;ACylCT;AD71BE;EAHF;IAII,mBAAA;ECg2BF;AACF;AD91BE;EACE,mBAAA;ACg2BJ;AD71BE;EACE,aArQK;AComCT;AD71BI;EAHF;IAII,aAAA;ECg2BJ;AACF;AD91BI;EACE,aAAA;ACg2BN;;AD31BA;EACE,gBAAA;EACA,uBAAA;EAAA,kBAAA;EACA,+CAAA;EACA,mBAAA;EACA,kBAAA;AC81BF;AD51BE;EACE,eAAA;AC81BJ;AD31BE;EACE,sCAAA;AC61BJ;AD11BE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,uBAAA;EACA,oNAAA;AC41BJ;;AD70BE;EACE,eAAA;EACA,gBAAA;EACA,cA/XqB;EAgYrB,gBAAA;EACA,kBAAA;EACA,kBAAA;ACg1BJ;AD90BI;EACE,kBAAA;ACg1BN;AD70BI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,UAAA;EACA,WAAA;EACA,mCAAA;AC+0BN;;AD10BA;EACE,8BAAA;AC60BF;;AD10BA;EACE,8BAAA;AC60BF;;AD10BA;EACE,+BAAA;AC60BF;;AD10BA;EACE,8BAAA;AC60BF;;AD10BA;EACE,mBAAA;EACA,oBAAA;EACA,mCAzbc;EA0bd,WAzZS;EA0ZT,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,wBAhdS;EAidT,qBAAA;EACA,qBAAA;EACA,kBAAA;EACA,iCAAA;AC60BF;AD30BE;EACE,2BAAA;EACA,mBAAA;AC60BJ;AD10BE;EACE,yBAzbiB;EA0bjB,WA1aO;ACsvCX;ADz0BE;EACE,eAAA;EACA,mBAAA;EACA,oBAAA;AC20BJ;ADx0BE;EACE,yBAjckB;EAkclB,cArciB;AC+wCrB;ADv0BE;EACE,yBAvbS;EAwbT,WA1bO;ACmwCX;ADv0BI;EACE,6BAAA;ACy0BN;;ADp0BA;EACE;IACE,uBAAA;ECu0BF;EDp0BA;IACE,yBAAA;ECs0BF;AACF;ADn0BA;EACE,8BAAA;ACq0BF;;ADl0BA;EACE,8BAAA;ACq0BF;;ADl0BA;EACE,+BAAA;ACq0BF;;ADl0BA;EACE,8BAAA;ACq0BF;;ADl0BA;EACE,qBAAA;ACq0BF;;ADl0BA;EACE,UAAA;ACq0BF;ADn0BE;EACE,qBAAA;ACq0BJ;;ADj0BA;EACE,UAAA;ACo0BF;;ADh0BE;EACE,YAAA;EACA,oCAAA;EAEA,aAAA;EACA,eAAA;EACA,gCAAA;ACk0BJ;AD/zBM;EACE,mBAAA;ACi0BR;AD5zBE;EACE,2BAAA;AC8zBJ;AD3zBE;EACE,uBAAA;AC6zBJ;AD1zBE;EACE,mBAAA;AC4zBJ;;ADvzBE;EACE,mBAAA;AC0zBJ;ADvzBE;EACE,yBAAA;ACyzBJ;ADtzBE;EACE,sBAAA;ACwzBJ;ADrzBE;EACE,uBAAA;ACuzBJ;ADpzBE;EACE,oBAAA;ACszBJ;;AE/3CA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAC3C,mBAAA;EAAqB,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EACzD,mBAAA;EACA,mBH6BoB;EG7Bc,cH0Bf;EG1B2C,yBAAA;AFy4ChE;AEv4CE;EAAU,eAAA;EAAiB,cHyBJ;ACk3CzB;;AEx4CA;EACE,oBAAA;EAAsB,WAAA;EAAa,YAAA;EAAc,kBAAA;EAAoB,mBHoBlD;EGnBnB,WAAA;EAAa,mBAAA;EAAqB,uBAAA;EAAyB,cAAA;EAAgB,gBAAA;EAAkB,cAAA;AFo5C/F;AEh5CE;EAAU,mBHwBG;EGxBwB,cHelB;ACq4CrB;;AAr6CA;EACE,uBAAA;EACA,iBAAA;EACA,wEDXW;ACm7Cb;;AAn6CA;EAAmB,gBAAA;AAu6CnB;;AAt6CA;EAAuB,eAAA;AA06CvB;;AAx6CA;EAAe,mBAAA;AA46Cf;;AAv6CA;EACE,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,kBAAA;AA06CF;AAx6CE;EANF;IAM8B,kBAAA;EA46C5B;AACF;;AA16CA;EACE,gBAAA;EAAkB,UAAA;EAAY,eAAA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,eAAA;EACnF,WDOkB;AC26CpB;AAj7CE;EAAK,aAAA;EAAe,mBAAA;AAq7CtB;AAr7C2C;EAA4B,YAAA;EAAc,aAAA;EAAe,WDMhF;ECN2G,eAAA;AA27C/H;AA17CE;EAAI,cDFe;ECEa,qBAAA;EAAuB,4BAAA;AA+7CzD;AA/7CuF;EAAU,uBDhBjF;ACk9ChB;AAj8CE;EAAa,cDEM;ECFsB,gBAAA;AAq8C3C;;AAn8CA;EACE,eAAA;EAAiB,gBAAA;EAAkB,cDDhB;ECC4C,SAAA;EAC/D,uBAAA;EAAyB,gBAAA;AA08C3B;;AAl8CA;EACE,aAAA;EAAe,gBAAA;EAAkB,UAAA;EAAY,gBAAA;AAw8C/C;AAv8CE;EACE,aAAA;EAAe,mBAAA;EAAqB,QAAA;EAAU,OAAA;EAAS,YAAA;EACvD,WDZgB;ECYW,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AAg9ClE;AA98CI;EAAe,cAAA;AAi9CnB;AA98CI;EACE,WAAA;EAAa,OAAA;EAAS,WAAA;EAAa,eAAA;EAAiB,cAAA;EACpD,mBAAA;EAAqB,kBAAA;AAq9C3B;AAn9CI;EAAsB,aAAA;AAs9C1B;AAr9CI;EAAmB,4BD3CP;ACmgDhB;AAt9CI;EAA4B,uBD7ChB;ACsgDhB;AAx9CI;EAAkB,mCAAA;EAAmC,mBAAA;AA49CzD;AA19CE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;EAAyB,WAAA;EAAa,YAAA;EACjF,kBAAA;EAAoB,mBAAA;EAAqB,WD7BzB;EC6BoD,eAAA;EAAiB,cAAA;AAo+CzF;AAl+CE;EAAW,mBAAA;AAq+Cb;AAn+CE;EAAoB,uBDtDN;AC4hDhB;AAr+CE;EACkC,4BDxDpB;ECwDgD,WAAA;AAw+ChE;;AAr+CA;EAA4B;IAAoB,aAAA;EA0+C9C;AACF;AAv+CA;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,cDrDmB;AC8hDrB;;AAl+CA;EACE,aAAA;EAAe,qCAAA;EAAuC,SAAA;EAAW,eAAA;AAw+CnE;AAv+CE;EAFF;IAE8B,0BAAA;EA2+C5B;AACF;;AAz+CA;EACE,aAAA;EAAe,sBAAA;EAAwB,QAAA;EAAU,kBAAA;EACjD,uBAAA;EAAyB,gBAAA;EACzB,yBAAA;EAAiC,mBAAA;EAAqB,gBAAA;EAAkB,eAAA;EACxE,iFAAA;EACA,gBAAA;AAm/CF;AAj/CE;EAAU,kBDjEQ;ACqjDpB;AAn/CE;EAAkB,mCAAA;EAAmC,mBAAA;AAu/CvD;AAn/CE;EACE,aAAA;EAAe,sBAAA;EAAwB,mBAAA;EAAqB,uBAAA;EAAyB,QAAA;EACrF,aAAA;EAAe,wBAAA;EACf,mBDxEkB;ECyElB,gCAAA;EACA,WD3EgB;ACqkDpB;AAz/CI;EAAM,eAAA;EAAiB,YAAA;AA6/C3B;AA5/CI;EAAO,eAAA;EAAiB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;AAkgDzE;AAhgDE;EAAuB,mCAAA;EAAwC,cAAA;AAogDjE;AAhgDE;EACE,8BDzGY;EC0GZ,mCAAA;EACA,4CAAA;AAkgDJ;AA//CE;EACE,kBAAA;EAAoB,SAAA;EAAW,WAAA;EAC/B,WAAA;EAAa,YAAA;EAAc,kBAAA;EAC3B,yBAAA;EAAiC,gBAAA;EACjC,oBAAA;EAAsB,mBAAA;EAAqB,uBAAA;AAwgD/C;AAvgDI;EAAM,cAAA;EAAgB,WAAA;EAAa,UAAA;EAAY,8BAAA;AA6gDnD;AA3gDE;EAAyB,8BDrHX;ECqHyC,4BDrHzC;ACooDhB;AA/gDqF;EAAM,UAAA;AAkhD3F;AAhhDE;EAAW,eAAA;EAAiB,gBAAA;EAAkB,cDpG3B;ECoGuD,mBAAA;AAshD5E;AArhDE;EAAU,eAAA;EAAiB,iBAAA;EAAmB,cD1G3B;EC0G8C,OAAA;AA2hDnE;AAxhDE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAC3C,iBAAA;EAAmB,gBAAA;EAAkB,cD1GpB;ACwoDrB;AA7hDI;EAAM,eAAA;EAAiB,WDzGP;AC0oDpB;AAhiDI;EAAY,cAvDJ;AA0lDZ;AAniDmC;EAAM,cAvD7B;AA6lDZ;AAniDE;EAAU,eAAA;EAAiB,iBAAA;EAAmB,6BAAA;AAwiDhD;AAviDE;EAAW,iBAAA;EAAmB,gBAAA;EAAkB,cA3DtC;AAumDZ;AA3iDE;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAC3C,eAAA;EAAiB,cDxHA;ECwHmB,kBAAA;AAijDxC;AAhjDI;EAAM,eAAA;AAmjDV;;AA/iDA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAC3C,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EAAkB,wEDlK3C;ECmKX,mCAAA;EAAkC,kBAAA;EAAoB,6BD5IxC;EC4IoE,WAAA;EAClF,eAAA;EAAiB,0DAAA;AA2jDnB;AA1jDE;EAAM,eAAA;AA6jDR;AA5jDE;EAAU,mBAAA;EAAwC,qBAAA;AAgkDpD;AA/jDE;EAAkB,mCAAA;EAAmC,mBAAA;AAmkDvD;;AA7jDA;EACE,aAAA;EAAe,8BAAA;EAAgC,mBAAA;EAAqB,SAAA;EACpE,oBAAA;EAAsB,oBAAA;EAAsB,6BAAA;AAqkD9C;AAnkDE;EAJF;IAI8B,oBAAA;IAAsB,oBAAA;EAwkDlD;AACF;;AAvkDA;EACE,uBD/Jc;EC+JS,eAAA;EAAiB,gBAAA;EAAkB,eAAA;AA6kD5D;AA5kDE;EAAU,0BAAA;AA+kDZ;;AA7kDA;EAAiB,aAAA;EAAe,mBAAA;EAAqB,SAAA;AAmlDrD;;AAjlDA;EAAe,eAAA;EAAiB,cDtJX;AC4uDrB;;AAplDA;EACE,oBAAA;EAAsB,mBAAA;EAAqB,QAAA;EAC3C,iBAAA;EAAmB,eAAA;EAAiB,gBAAA;EAAkB,wED7L3C;EC8LX,kBAAA;EAAoB,6BAAA;EAA+B,eAAA;EAAiB,gBAAA;EACpE,gBAAA;EAAkB,0BAAA;AAgmDpB;;AA9lDA;EACE,6BD3Kc;EC2Kc,WAAA;EAAa,+BD3K3B;AC8wDhB;AAlmDE;EAAU,mBAAA;EAAwC,qBAAA;AAsmDpD;;AApmDA;EACE,gBAAA;EAAkB,cDnKC;ECmK2B,qBDrJjC;AC8vDf;AAxmDE;EAAU,mBD5JU;EC4JwB,kBD7J1B;ACywDpB;;AAxmDA;EAAQ,aAAA;EAAe,sBAAA;EAAwB,SAAA;EAAW,gBAAA;AA+mD1D;;AA7mDA;EACE,SAAA;EAAW,yBAAA;EAAiC,kBAAA;EAAoB,gBAAA;EAAkB,gBAAA;AAonDpF;AAnnDE;EACE,aAAA;EAAe,SAAA;EAAW,kBAAA;EAAoB,gCAAA;AAwnDlD;AAvnDI;EAAe,gBAAA;AA0nDnB;AAxnDE;EACE,YAAA;EAAc,cAAA;EAAgB,iBAAA;EAAmB,gBAAA;EAAkB,yBAAA;EACnE,sBAAA;EAAwB,cDlLP;ECkL0B,gBAAA;AAgoD/C;AA9nDE;EAAK,SAAA;EAAW,eAAA;EAAiB,cD/Kd;EC+K0C,gBAAA;AAooD/D;AAnoDE;EAAS,gBAAA;EAAkB,cDrLR;AC4zDrB;;AApoDA;EACE,yBAAA;EAAiC,kBAAA;EAAoB,mBAAA;EAAqB,kBAAA;AA0oD5E;AAzoDE;EACE,iBAAA;EAAmB,gBAAA;EAAkB,yBAAA;EAA2B,sBAAA;EAChE,cD5LiB;EC4LE,cAAA;EAAgB,kBAAA;AAgpDvC;AA9oDE;EAAS,aAAA;EAAe,8BAAA;EAAgC,SAAA;EAAW,iBAAA;EAAmB,kBAAA;AAqpDxF;AAppDE;EAAU,cD/LS;ACs1DrB;AAtpDE;EACE,gBAAA;EAAkB,cD5LD;ACq1DrB;AAxpDI;EAAY,uBD7ME;ACw2DlB;AAzpDE;EAAU,iBAAA;EAAmB,cDpMV;ECoM6B,eAAA;AA8pDlD;;AA3pDA;EACE,aAAA;EAAe,QAAA;EAAU,eAAA;EAAiB,iBAAA;EAAmB,kBAAA;EAAoB,kBAAA;EACjF,mBAAA;EAAqB,cAAA;AAoqDvB;AAnqDE;EAAI,eAAA;AAsqDN;AArqDE;EAAS,mBAAA;EAAqB,cAAA;AAyqDhC;;AAtqDA;EAA4B;IAAQ,uBAAA;EA2qDlC;AACF;AA3qDA;EACE;IAAQ,uBAAA;EA8qDR;EA7qDA;IAAa,eAAA;EAgrDb;AACF","sourcesContent":["// Font\n$font-stack: \"open sans\", \"Helvetica Neue\", Helvetica, Arial, sans-serif;\n$muso-100: \"Museo-100\";\n$muso-300: \"Museo-300\";\n$muso-300-i: \"Museo-300Italic\";\n$muso-500: \"Museo-regular\";\n$muso-700: \"Museo-700\";\n$muso-700-i: \"Museo-700Italic\";\n$muso-sans: \"MuseoSans-300\";\n$car-font: \"Marydale\";\n$car-big-font: \"Bangers\", cursive;\n$font-museo: \"Conv_museo-500-webfont\";\n$font-helvetica: \"Helvetica\", \"open sans\";\n$MuseoSansCondensed-300: \"MuseoSansCondensed-300\";\n\n$fwBold: 700;\n\n//Foursight\n// $clarify-color: #06A6CE;\n// $ideate-color: #FF8300;\n// $develop-color: #7BBC43;\n// $implement-color: #FF485C;\n$clarify-color: rgba(0, 173, 208, 1);\n$ideate-color: rgba(255, 121, 0, 1);\n$develop-color: rgba(105, 190, 40, 1);\n$implement-color: rgba(245, 67, 89, 1);\n$low-clarify-color: rgba(0, 173, 208, 1);\n$low-ideate-color: rgba(255, 121, 0, 1);\n$low-develop-color: rgba(105, 190, 40, 1);\n$low-implement-color: rgba(245, 67, 89, 1);\n$profile-connector-color: #656668;\n// Profile Neutral color\n$integrator-color: #e3e3e3;\n// Team Report\n$report-integrator: #a7a7a7;\n// Body text color in reports\n$body-content-color: #676a6c;\n// Learner Map\n$gray-lm: rgba(0, 0, 0, 0.2);\n$border-color: #aaa;\n\n$color-neutral-dark: #6d6e71;\n$color-neutral-dark-500: #6a6a6a;\n$color-neutral-mid: #ccc;\n$color-neutral-light: #f1f1f2;\n$color-neutral-mid-old: #9e9e97;\n$color-dark-green: #4cae4c;\n$color-light-grey: #d9d9d9;\n$color-red: #ff485c;\n\n$color-grey-1: #e7eaec;\n\n$clrGray1: #f6f6f6;\n\n$clrDarkGray1: #ddd;\n\n$clrGrey: #eee;\n$clrWhite: #fff;\n$clrBlack: #000;\n$clrWarning: #f8ac59;\n\n$assets: \"https://assets.foursightonline.com/app\";\n$adminUpload: \"https://assets.foursightonline.com/admin-uploads/docs/\";\n\n$separator: \"\\//\";\n\n$active-class: #017ebc;\n\n// anchor Tag\n$anchor-color: #337ab7;\n\n//Sidebar\n$color-light-type: #fff;\n// submenu background\n$fs-dark-grey: #464646;\n// Hover\n$fs-active-light: #5f5f63;\n$fs-sidenav-bg: #333333;\n$fs-sidenav-hov-bg: #3e3e3f;\n$fs-green: #69be28;\n\n$clrInputAccent: #639935;\n\n$fn-fs-h1: 44px;\n$fn-fs-h1-mobile: 38px;\n$fn-lh-h1: 1.1;\n\n$fn-fs-h2: 38px;\n$fn-fs-h2-mobile: 32px;\n$fn-lh-h2: 1.2;\n\n$fn-fs-h3: 32px;\n$fn-fs-h3-mobile: 24px;\n$fn-lh-h3: 1.2;\n\n$fn-fs-h4: 24px;\n$fn-fs-h4-mobile: 20px;\n$fn-lh-h4: 1.2;\n\n$fn-fs-h5: 18px;\n$fn-lh-h5: 1.2;\n\n$fn-fs-h6: 16px;\n$fn-lh-h6: 1.3;\n\n$fn-title-subtext: 22px;\n$fn-title-subtext-mobile: 18px;\n\n$pageWidth: 1080px;\n$pageWidthSmall: 820px;\n$pageWidthFluid: 1200px;\n\n$secPad: 60px;\n\n$pageWidth: 1080px;\n$pageWidthFluid: 1200px;\n\n$desktop: \"only screen and (max-width: 1600px)\";\n$mac: \"only screen and (max-width: 1350px)\";\n$pc-up: \"only screen and (min-width: 1200px)\";\n$pc: \"only screen and (max-width: 1199px)\";\n$tablet-up: \"only screen and (min-width: 992px)\";\n$tablet: \"only screen and (max-width: 991px)\";\n$mobile-up: \"only screen and (min-width: 768px)\";\n$mobile: \"only screen and (max-width: 767px)\";\n$xl: \"only screen and (max-width: 1440px)\";\n$xl-up: \"only screen and (min-width: 1440px)\";\n\nimg {\n  max-width: 100%;\n}\n\n.flex {\n  display: flex;\n  flex-wrap: wrap;\n}\n\n.dir-col {\n  flex-direction: column;\n}\n\n.dir-col-rev {\n  flex-direction: column-reverse;\n}\n\n.mh-full {\n  min-height: 100%;\n}\n\n.mt-auto {\n  margin-top: auto;\n}\n\n.bt-0 {\n  border-top: 0;\n}\n\n.bb-0 {\n  border-bottom: 0;\n}\n\n@mixin headingfont() {\n  font-family: $muso-700 !important;\n  font-weight: normal !important;\n}\n\n@mixin contentfont() {\n  font-family: $muso-300 !important;\n  font-weight: normal !important;\n}\n\n.fn-body {\n  h1,\n  h2,\n  h3,\n  h4,\n  h5,\n  h6 {\n    --hGap: 10px;\n    font-family: $muso-700;\n    color: $color-neutral-dark;\n    margin-bottom: var(--hGap);\n    margin-top: 0;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n  }\n\n  h1,\n  .h1-text {\n    font-size: $fn-fs-h1;\n    line-height: $fn-lh-h1;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h1-mobile;\n    }\n  }\n\n  h2,\n  .h2-text {\n    font-size: $fn-fs-h2;\n    line-height: $fn-lh-h2;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h2-mobile;\n    }\n  }\n\n  h3,\n  .h3-text {\n    font-size: $fn-fs-h3;\n    line-height: $fn-lh-h3;\n\n    @media #{$mobile} {\n      font-size: $fn-fs-h3-mobile;\n    }\n  }\n\n  h4,\n  .h4-text {\n    font-size: $fn-fs-h4;\n    line-height: $fn-lh-h4;\n  }\n\n  h5,\n  .h5-text {\n    font-size: $fn-fs-h5;\n    line-height: $fn-lh-h5;\n  }\n\n  h6,\n  .h6-text {\n    font-size: $fn-fs-h6;\n    line-height: $fn-lh-h6;\n  }\n\n  $fn-title-subtext: 22px;\n  $fn-title-subtext-mobile: 18px;\n\n  p {\n    font-size: 18px;\n    line-height: 1.6;\n    color: $color-neutral-dark-500;\n    margin-top: 0;\n    margin-bottom: 10px;\n\n    &:last-child {\n      margin-bottom: 0;\n    }\n\n    @media #{$mobile} {\n      font-size: 16px;\n    }\n  }\n\n  ul,\n  ol {\n    padding: 0;\n    margin: 0;\n  }\n\n  sup {\n    font-size: 0.7em;\n    position: relative;\n    top: 5px;\n    display: inline-block;\n    vertical-align: top;\n  }\n}\n\n.bg-grey {\n  background-color: $clrGrey;\n}\n\n.fn-container {\n  max-width: $pageWidth;\n  width: calc(100% - 30px);\n  margin-inline: auto;\n\n  @media #{$tablet-up} {\n    margin-left: 0;\n  }\n\n  &--fluid {\n    max-width: $pageWidthFluid;\n  }\n\n  &--small {\n    max-width: $pageWidthSmall;\n    width: 100%;\n  }\n}\n\n.text {\n  &-center {\n    text-align: center;\n  }\n\n  &-right {\n    text-align: right;\n  }\n}\n\n.d {\n  &-none {\n    display: none;\n  }\n}\n\n.section-title {\n  text-align: center;\n\n  &:not(:last-child) {\n    margin-bottom: calc($secPad - 20px);\n  }\n\n  h2 {\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n  }\n\n  p {\n    max-width: 900px;\n    width: 100%;\n    margin-inline: auto;\n    font-size: $fn-title-subtext;\n\n    &:not(:last-child) {\n      margin-block-end: calc($secPad / 3);\n    }\n\n    @media #{$mobile} {\n      font-size: $fn-title-subtext-mobile;\n    }\n  }\n\n  .section-title__linkcontainer {\n    display: flex;\n    flex-wrap: wrap;\n    justify-content: center;\n    align-items: center;\n\n    &:not(:last-child) {\n      margin-block-end: 20px;\n    }\n\n    & > * {\n      margin: 5px;\n    }\n\n    .fn-btn {\n      padding-block: 6px;\n      padding-inline: 13px;\n      font-size: 12px;\n      font-family: $muso-sans;\n    }\n  }\n}\n\n.section-padding {\n  padding-block: $secPad;\n\n  @media #{$mobile} {\n    padding-block: ($secPad - 20px);\n  }\n\n  &-small {\n    padding-block: calc($secPad / 2);\n  }\n\n  &-all {\n    padding: $secPad;\n\n    @media #{$mobile} {\n      padding: calc($secPad / 2);\n    }\n\n    &-small {\n      padding: calc($secPad / 2);\n    }\n  }\n}\n\n.headline {\n  --lineSize: 10px;\n  width: fit-content;\n  padding-block-end: calc(10px + var(--lineSize));\n  margin-inline: auto;\n  position: relative;\n\n  &--small-border {\n    --lineSize: 6px;\n  }\n\n  &:not(:last-child) {\n    margin-bottom: calc(var(--hGap) * 2.5);\n  }\n\n  &::before {\n    content: \"\";\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    width: 100%;\n    height: var(--lineSize);\n    background: linear-gradient(\n      90deg,\n      $clarify-color 0%,\n      $clarify-color 25%,\n      $ideate-color 25%,\n      $ideate-color 50%,\n      $develop-color 50%,\n      $develop-color 75%,\n      $implement-color 75%,\n      $implement-color 100%\n    );\n  }\n}\n\n.custom-list {\n  li {\n    font-size: 18px;\n    line-height: 1.4;\n    color: $color-neutral-dark-500;\n    list-style: none;\n    position: relative;\n    padding-left: 15px;\n\n    &:not(:last-child) {\n      margin-bottom: 4px;\n    }\n\n    &::before {\n      content: \"\";\n      position: absolute;\n      top: 10px;\n      left: 0;\n      width: 3px;\n      height: 3px;\n      background-color: var(--clrProfile);\n    }\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.fn-btn {\n  padding-block: 20px;\n  padding-inline: 28px;\n  background-color: $develop-color;\n  color: $clrWhite;\n  font-size: 18px;\n  line-height: 1.2;\n  display: inline-block;\n  font-family: $muso-700;\n  text-decoration: none;\n  word-break: break-all;\n  text-align: center;\n  transition: background-color 0.3s;\n\n  &:focus {\n    outline: 1px dashed $color-neutral-dark-500;\n    outline-offset: 4px;\n  }\n\n  &:hover {\n    background-color: $color-neutral-dark;\n    color: $clrWhite;\n  }\n\n  &--sm {\n    font-size: 14px;\n    padding-block: 10px;\n    padding-inline: 20px;\n  }\n\n  &--grey {\n    background-color: $color-neutral-light;\n    color: $color-neutral-dark;\n  }\n\n  &--ongoing {\n    background-color: $clrWarning;\n    color: $clrWhite;\n\n    i {\n      animation: spin 0.3s infinite;\n    }\n  }\n}\n\n@keyframes spin {\n  from {\n    transform: rotate(0deg);\n  }\n\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.color-clarify {\n  --clrProfile: #{$clarify-color};\n}\n\n.color-ideate {\n  --clrProfile: #{$ideate-color};\n}\n\n.color-develop {\n  --clrProfile: #{$develop-color};\n}\n\n.color-implement {\n  --clrProfile: #{$implement-color};\n}\n\n.w-4 {\n  width: calc(100% / 3);\n}\n\n.w-3 {\n  width: calc(100% / 4);\n\n  &--wd {\n    width: calc(100% / 3);\n  }\n}\n\n.w-6 {\n  width: calc(100% / 2);\n}\n\n.fn {\n  &-row {\n    --rGap: 15px;\n    --rGap-minus: calc(-1 * var(--rGap));\n\n    display: flex;\n    flex-wrap: wrap;\n    margin-inline: var(--rGap-minus);\n\n    &--col-gap-exist {\n      .fn-col {\n        margin-bottom: calc($secPad / 2);\n      }\n    }\n  }\n\n  &-col {\n    padding-inline: var(--rGap);\n  }\n\n  &-justify-center {\n    justify-content: center;\n  }\n\n  &-items-center {\n    align-items: center;\n  }\n}\n\n.m {\n  &x-auto {\n    margin-inline: auto;\n  }\n\n  &l-auto {\n    margin-inline-start: auto;\n  }\n\n  &l-0 {\n    margin-inline-start: 0;\n  }\n\n  &r-auto {\n    margin-inline-end: auto;\n  }\n\n  &r-0 {\n    margin-inline-end: 0;\n  }\n}\n","@import \"../../../../assets/styles/variables\";\n@import \"../../invitations/_inv-form\";\n@import \"../_rep-shared\";\n\n// $color-neutral-mid is #ccc — a hairline grey, ~1.6:1 on white. Muted TEXT uses this instead.\n$rep-muted: $body-content-color;\n\n// Wide enough for three report-type cards in a row, but not full-bleed. The plain text fields are\n// capped separately below so they don't stretch to this width — only the type grid uses all of it.\n.repw {\n  padding: 32px 48px 48px;\n  max-width: 1120px;\n  font-family: $font-stack;\n}\n\n// Title and owner stay at a readable measure even though the wizard is now wide; the type field\n// opts out so its card grid can span the full width.\n.repw .inv-field { max-width: 680px; }\n.repw .rep-typefield { max-width: none; }\n\n.repw-header { margin-bottom: 22px; }\n\n// The form sits on a white card so it reads as a contained surface, not floating on the page.\n// Border-only, 8px radius — the SAME surface as the listing's table card. An elevated shadow read\n// as a modal dropped onto the page; a flat bordered card reads as part of the page instead.\n.repw-card {\n  background: #fff;\n  border: 1px solid $color-grey-1;\n  border-radius: 8px;\n  padding: 26px 28px;\n\n  @media (max-width: 640px) { padding: 20px 18px; }\n}\n// Breadcrumb kept in lock-step with the listing: grey at rest, Clarify blue on hover, bold current.\n.repw-breadcrumb {\n  list-style: none; padding: 0; margin: 0 0 8px; display: flex; align-items: center; font-size: 12px;\n  color: $color-neutral-mid;\n  li { display: flex; align-items: center; &:not(:last-child)::after { content: \"/\"; margin: 0 8px; color: $color-neutral-mid; font-size: 11px; } }\n  a { color: $body-content-color; text-decoration: none; transition: color 0.15s ease; &:hover { color: $clarify-color; } }\n  &__current { color: $color-neutral-dark; font-weight: 600; }\n}\n.repw-header__title {\n  font-size: 28px; font-weight: 700; color: $color-neutral-dark; margin: 0;\n  letter-spacing: -0.02em; line-height: 1.2;\n}\n\n// ── Stepper ───────────────────────\n// Mirrors the Invitations wizard exactly: numbered circles joined by connector lines, Clarify blue\n// for the active and completed steps. Its own class (not .inv-steps) because that lives in\n// invitation-create.component.scss and is only injected when THAT component instantiates, which\n// never happens on /reports/new — but the visual language is identical on purpose.\n.rep-steps {\n  display: flex; list-style: none; padding: 0; margin: 0 0 22px;\n  &__item {\n    display: flex; align-items: center; gap: 7px; flex: 1; min-width: 0;\n    color: $color-neutral-mid; font-size: 12px; font-weight: 600; cursor: pointer;\n\n    &:last-child { flex: 0 0 auto; }\n\n    // connector line running to the next step's circle\n    &::after {\n      content: ''; flex: 1; height: 2px; min-width: 18px; margin: 0 12px;\n      background: #eef0f1; border-radius: 2px;\n    }\n    &:last-child::after { display: none; }\n    &.is-done::after { background: $clarify-color; }\n\n    &:hover .rep-steps__label { color: $clarify-color; }\n    &:focus-visible { outline: 2px solid $clarify-color; outline-offset: 2px; }\n  }\n  &__num {\n    display: inline-flex; align-items: center; justify-content: center; width: 22px; height: 22px;\n    border-radius: 50%; background: #eef0f1; color: $color-neutral-mid; font-size: 11px; flex-shrink: 0;\n  }\n  &__label { white-space: nowrap; }\n\n  &__item.is-active { color: $clarify-color; }\n  &__item.is-active .rep-steps__num,\n  &__item.is-done .rep-steps__num { background: $clarify-color; color: #fff; }\n}\n\n@media (max-width: 560px) { .rep-steps__label { display: none; } }\n\n// Explanatory note under a field. NOT .inv-hint from _inv-form: that one is $color-neutral-mid\n// (#ccc, ~1.6:1) — an existing invitations bug, and these hints carry real guidance.\n.rep-hint {\n  margin: 5px 0 0;\n  font-size: 11.5px;\n  line-height: 1.4;\n  color: $rep-muted;\n}\n\n// ── Report type cards ───────────────────────\n// A green readable enough for small bold text on white — $develop-color (lime) is too light.\n$rep-green: #4a8c1c;\n\n.rep-typegrid {\n  display: grid; grid-template-columns: repeat(3, 1fr); gap: 12px; margin-top: 2px;\n  @media (max-width: 900px) { grid-template-columns: 1fr; }\n}\n\n.rep-typecard {\n  display: flex; flex-direction: column; gap: 6px; position: relative;\n  padding: 16px 16px 14px; text-align: left;\n  border: 1px solid $color-grey-1; border-radius: 10px; background: #fff; cursor: pointer;\n  transition: border-color 0.15s ease, background 0.15s ease, box-shadow 0.15s ease;\n  overflow: hidden;   // keep the bleeding preview image inside the rounded top corners\n\n  &:hover { border-color: $color-neutral-mid; }\n  &:focus-visible { outline: 2px solid $clarify-color; outline-offset: 2px; }\n\n  // Placeholder for the report's preview image — a light panel bleeding to the card's top edges.\n  // Swap for a real <img> render when the reporting API lands.\n  &__img {\n    display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 5px;\n    height: 190px; margin: -16px -16px 12px;   // taller: report PDFs render portrait\n    background: $color-neutral-light;\n    border-bottom: 1px solid $color-grey-1;\n    color: $color-neutral-mid;\n    .fa { font-size: 24px; opacity: 0.7; }\n    span { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.07em; }\n  }\n  &.is-selected &__img { background: rgba($clarify-color, 0.08); color: darken($clarify-color, 8%); }\n\n  // Selected reads with the same Clarify blue as the stepper and the combobox — the app's\n  // \"current / chosen\" colour. Green is reserved for the primary action and the free/price text.\n  &.is-selected {\n    border-color: $clarify-color;\n    background: rgba($clarify-color, 0.04);\n    box-shadow: inset 0 0 0 1px $clarify-color;\n  }\n\n  &__radio {\n    position: absolute; top: 14px; right: 14px;\n    width: 18px; height: 18px; border-radius: 50%;\n    border: 1px solid $color-grey-1; background: #fff;\n    display: inline-flex; align-items: center; justify-content: center;\n    .fa { font-size: 9px; color: #fff; opacity: 0; transition: opacity 0.15s ease; }\n  }\n  &.is-selected &__radio { border-color: $clarify-color; background: $clarify-color; .fa { opacity: 1; } }\n\n  &__title { font-size: 14px; font-weight: 700; color: $color-neutral-dark; padding-right: 24px; }\n  &__desc { font-size: 12px; line-height: 1.45; color: $rep-muted; flex: 1; }\n\n  // Key requirement — a \"key\" glyph for paid types, a green check for the free one.\n  &__key {\n    display: inline-flex; align-items: center; gap: 6px;\n    font-size: 11.5px; font-weight: 600; color: $color-neutral-dark;\n    .fa { font-size: 11px; color: $color-neutral-mid; }\n    &.is-free { color: $rep-green; .fa { color: $rep-green; } }\n  }\n\n  &__foot { margin-top: 8px; padding-top: 10px; border-top: 1px solid $color-neutral-light; }\n  &__price { font-size: 11.5px; font-weight: 700; color: $rep-green; }\n  &__soon {\n    display: inline-flex; align-items: center; gap: 5px;\n    font-size: 11px; color: $rep-muted; font-style: italic;\n    .fa { font-size: 11px; }\n  }\n}\n\n.rep-buybtn {\n  display: inline-flex; align-items: center; gap: 6px;\n  padding: 6px 12px; font-size: 12px; font-weight: 600; font-family: $font-stack;\n  border: 1px solid $develop-color; border-radius: 6px; background: $develop-color; color: #fff;\n  cursor: pointer; transition: background 0.15s ease, border-color 0.15s ease;\n  .fa { font-size: 11px; }\n  &:hover { background: darken($develop-color, 8%); border-color: darken($develop-color, 8%); }\n  &:focus-visible { outline: 2px solid $clarify-color; outline-offset: 2px; }\n}\n\n// ── Footer + CTAs (matches the Invitations wizard footer) ──\n// The divider bleeds to the card edges (negative margins cancel the card's 28px padding), then\n// re-pads its own contents — so the rule reads as a true card footer, not a line floating inside.\n.repw__footer {\n  display: flex; justify-content: space-between; align-items: center; gap: 12px;\n  margin: 24px -28px 0; padding: 16px 28px 0; border-top: 1px solid $color-grey-1;\n\n  @media (max-width: 640px) { margin: 20px -18px 0; padding: 14px 18px 0; }\n}\n.repw__cancel {\n  color: $clarify-color; font-size: 13px; font-weight: 600; cursor: pointer;\n  &:hover { text-decoration: underline; }\n}\n.repw__actions { display: flex; align-items: center; gap: 10px; }\n// Why the next step is blocked — guidance, not an error, so muted rather than alarm red.\n.repw__block { font-size: 12px; color: $rep-muted; }\n\n.repw__footer .btn {\n  display: inline-flex; align-items: center; gap: 6px;\n  padding: 9px 18px; font-size: 13px; font-weight: 600; font-family: $font-stack;\n  border-radius: 6px; border: 1px solid transparent; cursor: pointer; line-height: 1.4;\n  box-shadow: none; transition: all 0.15s ease;\n}\n.repw__footer .btn-primary {\n  background: $develop-color; color: #fff; border-color: $develop-color;\n  &:hover { background: darken($develop-color, 8%); border-color: darken($develop-color, 8%); }\n}\n.repw__footer .btn-white {\n  background: #fff; color: $body-content-color; border-color: $color-grey-1;\n  &:hover { background: $color-neutral-light; border-color: $color-neutral-mid; }\n}\n\n// ── Review ───────────────────────\n.repr { display: flex; flex-direction: column; gap: 18px; max-width: 620px; }\n\n.repr-summary {\n  margin: 0; border: 1px solid $color-grey-1; border-radius: 8px; background: #fff; overflow: hidden;\n  &__row {\n    display: flex; gap: 16px; padding: 11px 14px; border-bottom: 1px solid #f1f1f2;\n    &:last-child { border-bottom: 0; }\n  }\n  dt {\n    width: 110px; flex-shrink: 0; font-size: 10.5px; font-weight: 700; text-transform: uppercase;\n    letter-spacing: 0.05em; color: $rep-muted; padding-top: 2px;\n  }\n  dd { margin: 0; font-size: 13px; color: $color-neutral-dark; font-weight: 600; }\n  &__sub { font-weight: 400; color: $rep-muted; }\n}\n\n.repr-mix, .repr-byorg {\n  border: 1px solid $color-grey-1; border-radius: 8px; background: #fafafa; padding: 12px 14px;\n  &__label {\n    font-size: 10.5px; font-weight: 700; text-transform: uppercase; letter-spacing: 0.05em;\n    color: $rep-muted; display: block; margin-bottom: 8px;\n  }\n  &__row { display: flex; justify-content: space-between; gap: 12px; font-size: 12.5px; margin-bottom: 4px; }\n  &__name { color: $rep-muted; }\n  &__n {\n    font-weight: 700; color: $color-neutral-dark;\n    &.is-zero { color: $implement-color; }\n  }\n  &__note { font-size: 10.5px; color: $rep-muted; margin: 8px 0 0; }\n}\n\n.repr-warn {\n  display: flex; gap: 8px; font-size: 12px; line-height: 1.45; border-radius: 6px; padding: 10px 12px;\n  background: #fff4e5; color: #8a5a00;\n  i { margin-top: 1px; }\n  &--cap { background: #fdeaec; color: #a3283a; }\n}\n\n@media (max-width: 991px) { .repw { padding: 24px 24px 40px; } }\n@media (max-width: 640px) {\n  .repw { padding: 16px 16px 32px; }\n  .rep-steps { flex-wrap: wrap; }\n}\n","// Shared invitation form language — the field grid, labels, controls, validation and\n// notes used by app-invitation-step-details / -step-schedule.\n//\n// This lives in a partial rather than invitation-create.component.scss because those steps\n// render in TWO hosts: the create wizard and the edit modal. Component styles (encapsulation\n// None) are only injected once their component is first instantiated, and app-invitation-create\n// only exists on the invitations LIST page — so opening Edit from a detail page you deep-linked\n// to left the whole form unstyled. Both hosts now @import this.\n\n@import \"../../../assets/styles/variables\";\n\n// ── Form grid + fields ───────────────────────\n.inv-form-grid { display: grid; grid-template-columns: 1fr; gap: 16px 18px; }\n.inv-field { display: flex; flex-direction: column; margin-bottom: 16px; }\n.inv-form-grid .inv-field { margin-bottom: 0; } // grid uses gap; reset here\n.inv-field--full, .inv-key-notice { grid-column: 1 / -1; }\n\n.inv-field label {\n  font-size: 11px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $color-neutral-dark;\n  margin-bottom: 6px;\n  font-family: $font-stack;\n}\n\n.inv-field .form-control,\n.inv-org-row .form-control {\n  height: auto;\n  padding: 9px 12px;\n  font-size: 13px;\n  font-family: $font-stack;\n  color: $body-content-color;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  background: #fff;\n  box-shadow: none;\n  transition: border-color 0.2s ease, box-shadow 0.2s ease;\n\n  &::placeholder { color: $color-neutral-mid; }\n  &:focus { border-color: $clarify-color; box-shadow: 0 0 0 3px rgba($clarify-color, 0.1); outline: none; }\n}\ntextarea.form-control { min-height: 240px; resize: vertical; line-height: 1.6; }\n\n// Native selects render as an OS widget that ignores the box styling above — only the font came\n// through, so they sat short and square next to the inputs and the Organization combobox. Opting\n// out of the widget lets the shared rule apply, and we draw the chevron ourselves (inline SVG so\n// there's no asset request). Padding-right clears the arrow.\n.inv-field select.form-control,\n.inv-org-row select.form-control {\n  appearance: none;\n  -webkit-appearance: none;\n  padding-right: 34px;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' fill='none' stroke='%23949699' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 12px center;\n  cursor: pointer;\n}\n\n// Validation: red border on touched-invalid controls + inline message under the field.\n.inv-field .form-control.ng-invalid.ng-touched,\n.inv-org-row .form-control.ng-invalid.ng-touched {\n  border-color: $implement-color;\n  &:focus { border-color: $implement-color; box-shadow: 0 0 0 3px rgba($implement-color, 0.12); }\n}\n.inv-error {\n  margin-top: 5px;\n  font-size: 11.5px;\n  line-height: 1.4;\n  color: $implement-color;\n}\n// Explanatory note under a field — states a default the form applied for you.\n.inv-hint {\n  margin: 5px 0 0;\n  font-size: 11.5px;\n  line-height: 1.4;\n  color: $color-neutral-mid;\n}\n\n// Read-only field value (edit modal) — keeps .form-control's box so the form's rhythm holds,\n// but reads as inert: muted fill, dashed edge, no focus ring, a trailing lock.\n.inv-locked {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  min-height: 38px;\n  padding: 8px 12px;\n  border: 1px dashed $color-grey-1;\n  border-radius: 6px;\n  background: $color-neutral-light;\n  cursor: default;\n\n  &__value {\n    flex: 1;\n    min-width: 0;\n    font-size: 13px;\n    color: $color-neutral-mid;\n    line-height: 1.4;\n  }\n  &__icon {\n    flex: 0 0 auto;\n    font-size: 11px;\n    color: $color-neutral-mid;\n    opacity: 0.75;\n  }\n}\n\n// Explains the pair of locked fields above it — indented to read as their footnote.\n.inv-locked-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 7px;\n  margin: -6px 0 0;\n  font-size: 11.5px;\n  line-height: 1.45;\n  color: $color-neutral-mid;\n\n  &::before {\n    content: '\\f05a'; // fa-info-circle\n    font-family: FontAwesome;\n    font-size: 11px;\n    line-height: 1.45;\n    opacity: 0.8;\n  }\n}\n\n// Info callout — a constraint the user needs before they pick, not an error.\n.inv-note {\n  display: flex;\n  align-items: flex-start;\n  gap: 9px;\n  padding: 10px 12px;\n  border: 1px solid rgba($clarify-color, 0.28);\n  border-radius: 8px;\n  background: rgba($clarify-color, 0.06);\n\n  &__icon {\n    flex: 0 0 auto;\n    margin-top: 1px;\n    font-size: 13px;\n    color: $clarify-color;\n  }\n  &__text {\n    margin: 0;\n    font-size: 12.5px;\n    line-height: 1.5;\n    color: $body-content-color;\n    strong { font-weight: 600; }\n  }\n}\n\n// follow-up checkbox row\n.inv-field--full {\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  font-size: 13px;\n  color: $body-content-color;\n}\n\n// organizer-role explainer note (step 2)\n.inv-role-note {\n  background: $color-neutral-light;\n  border: 1px solid $color-grey-1;\n  border-radius: 6px;\n  padding: 12px 14px;\n  margin-bottom: 16px;\n  font-size: 12.5px;\n  line-height: 1.55;\n  color: $body-content-color;\n\n  ul { margin: 6px 0 0; padding-left: 18px; }\n  li { margin: 2px 0; }\n  strong { color: $color-neutral-dark; }\n}\n\n// inline profile-key notice\n.inv-key-notice {\n  background: #fff8e6;\n  border: 1px solid #f3e0a8;\n  border-radius: 6px;\n  padding: 10px 14px;\n  font-size: 12px;\n  color: #8a6d1a;\n  line-height: 1.5;\n}\n\n// Section heading — a ruled divider so a long form reads as parts rather than one list.\n.inv-section-title {\n  font-size: 12px;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  color: $color-neutral-dark;\n  margin: 26px 0 16px;\n  padding-top: 20px;\n  border-top: 1px solid $color-grey-1;\n}\n\n// Date pairs sit side by side once there's room — the schedule is a sequence, and stacking\n// deadline over presentation over coaching buries the order in scroll.\n@media (min-width: 720px) {\n  .inv-form-grid--pairs { grid-template-columns: 1fr 1fr; }\n}\n\n","// Report chrome shared by the listing and the wizard's review step.\n//\n// A partial, not classes borrowed from another component: Angular injects a component's styles\n// only when that component first instantiates, so anything defined in reports-list.component.scss\n// simply does not exist on /reports/new. This is the same trap _inv-form.scss was extracted to\n// solve — and the same reason .inv-pill / .inv-avatar cannot be reused from invitations at all.\n\n@import \"../../../assets/styles/variables\";\n\n// Report type pill. Deliberately monochrome — the three types differ by their leading icon\n// (group / group-plus / single member), not colour. The label always spells the type out too.\n.rep-pill {\n  display: inline-flex; align-items: center; gap: 5px;\n  border-radius: 10px; padding: 3px 10px; font-size: 11px; font-weight: 600;\n  white-space: nowrap;\n  background: $color-neutral-light; color: $color-neutral-dark; border: 1px solid $color-grey-1;\n\n  &__icon { font-size: 10px; color: $color-neutral-dark-500; }\n}\n\n.rep-avatar {\n  display: inline-flex; width: 26px; height: 26px; border-radius: 50%; background: $color-neutral-dark;\n  color: #fff; align-items: center; justify-content: center; font-size: 9px; font-weight: 700; flex-shrink: 0;\n\n  // Listing avatars are neutral, matching the Invitations \"Organizer\" column: the creator is\n  // context, not a status signal, so it must not read as loud as the type pill beside it.\n  &--grey { background: $color-grey-1; color: $color-neutral-dark; }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
